import {Component, HostListener, OnInit} from '@angular/core';
import {User} from '../../../models/user';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {UserRole} from '../../../models/user-role';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {Subject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {Title} from '@angular/platform-browser';
import {TitleBroadcastService} from '../../../services/title-broadcast.service';
import {MatSelectChange} from '@angular/material';
import {MonitoringUserLastLocations} from '../../../models/monitoring-user-last-locations';
import * as L from 'leaflet';
import {DivIcon} from 'leaflet';
import 'leaflet.gridlayer.googlemutant';
import {base_urls} from '../../../config/base_urls';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-monitoring-last-locations',
    templateUrl: './monitoring-last-locations.component.html',
    styleUrls: ['./monitoring-last-locations.component.scss']
})
export class MonitoringLastLocationsComponent implements OnInit {

    constructor(private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title,
                private titleBroadcastService: TitleBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('Monitor Last Locations');
        this.loggedUser = auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach(marketLevel => {
            this.markets[marketLevel.Rank] = [];
            this.selectedMarket[marketLevel.Rank] = null;
        });
    }

    lat = 23.8383283;
    lng = 90.3759853;
    loggedUser: User;

    locationList: MonitoringUserLastLocations[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    userRoles: UserRole[];
    map: any;
    filters = {
        'date': moment().set({hour: 0, minute: 0, second: 0}).format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        'marketIdList': null,
        'searchKey': null,
        'userRoleId': null
    };

    userType = 'ORGANIZATION_USER';

    markerClusterGroup = L.markerClusterGroup({
        iconCreateFunction: function (cluster): DivIcon {
            const count = cluster.getChildCount();
            return L.divIcon({
                html: '<div style="background-color: rgba(17,156,231,0.8);' +
                    'border-radius: 50%; ' +
                    'height: 40px; ' +
                    'width: 40px; ' +
                    'font-size: 10px; ' +
                    'font-weight: 700; ' +
                    'display: flex; ' +
                    'justify-content: center; ' +
                    'font-family: Muli; ' +
                    'border: 2px solid rgba(45,45,45,0.5); ' +
                    'align-items: center;">' + count + '</div>',
                className: '',
                iconSize: L.point(40, 40)
            });
        }
    });

    customStyle = [
        {
            'featureType': 'landscape',
            elementType: 'geometry',
            'stylers': [
                {'hue': '#37cb37'},
                {'saturation': -20},
                {'lightness': -8}
            ]
        }
    ];

    private _unsubscribeAll: Subject<any>;

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.getLocationList();
        }
    }

    ngOnInit(): void {
        this.map = L.map('map').setView([23.8383283, 90.3759853], 7);
        L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: this.customStyle
        }).addTo(this.map);

        // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        //     attribution:
        //         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        // }).addTo(this.map);

        this.titleService.setTitle('Monitoring User Last Locations');
        this.service.getUserRoleList({}).subscribe(pUserRoles => this.userRoles = pUserRoles);
        this.service.getMarketList({MarketLevelId: this.marketLevels[0].Id, Active: true}).subscribe(pMarkets => this.markets[1] = pMarkets);
    }


    setDate(pEvent): void {
        const eventDate = moment(pEvent.value);
        eventDate.set('hour', 0);
        eventDate.set('minute', 0);
        eventDate.set('second', 0);
        this.filters.date = moment(eventDate).format(SERVER_DATE_FORMAT_WITHOUT_TIME);
    }

    _resetChildrenDropdown(pParentRank: number): void {
        this.marketLevels.forEach(pMarketLevel => {
            if (pMarketLevel.Rank > pParentRank) {
                this.selectedMarket[pMarketLevel.Rank] = null;
                this.markets[pMarketLevel.Rank] = [];
            }
        });
    }

    populateChildrenMarkets(event: MatSelectChange): void {
        const market: Market = event.value;
        if (market) {
            this._resetChildrenDropdown(market.MarketRank);
            if (this.marketLevels[market.MarketRank]) {
                this.service.getMarketList({
                    MarketLevelId: this.marketLevels[market.MarketRank].Id,
                    ParentMarketId: market.Id,
                    Active: true
                }).subscribe(pMarketList => this.markets[market.MarketRank + 1] = pMarketList);
            }
        } else {
            this._resetChildrenDropdown(parseInt(event.source.id.slice(6), 10));
        }
    }


    getLocationList(): void {
        this.filters.marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.filters.marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }
        this.markerClusterGroup.clearLayers();

        this.loadingData = true;
        this.service.getMonitoringUserLastLocations(this.filters, base_urls.hrws).subscribe(locationList => {
            this.loadingData = false;
            if (locationList.length > 0) {
                locationList.forEach(pLocation => {
                    const monitorUrl = `/location/monitoring-user-timeline?userCode=${pLocation.user.code}`;
                    if ((pLocation.latitude > 0 && pLocation.latitude <= 90) && (pLocation.longitude > 0 && pLocation.longitude <= 180)) {
                        const customIcon = L.divIcon({
                            html: '<div>' +
                                `<img src="/assets/icons/markers/ic_pin_red.svg" style="width: 50px; height: 50px; position: relative" >` +
                                `<img src="${pLocation.user.imageUrl || '/assets/images/no_image.jpg'}" style="width: 31px; height: 30px; left: 9px; top: 2px; border-radius: 50%; position: absolute" >` +
                                '</div>',
                            iconSize: [50, 50],
                            iconAnchor: [25, 50],
                            className: ''
                        });
                        let lastUpdated = '';
                        if (pLocation.tillTime) {
                            const now = new Date();
                            const updated = new Date(pLocation.tillTime);
                            const diffMs = now.getTime() - updated.getTime();
                            const diffMins = Math.floor(diffMs / 60000);

                            if (diffMins < 60) {
                                lastUpdated = diffMins <= 1 ? 'a minute ago' : `${diffMins} minutes ago`;
                            } else {
                                lastUpdated = 'at ' + new DatePipe('en-US').transform(updated, 'h:mm a');
                            }
                        }
                        const marker = L.marker([pLocation.latitude, pLocation.longitude], {icon: customIcon})
                            .bindPopup(`
                                        <div style="display: flex; align-items: center">
                                            <div style="border-right: 2px solid #c7c3c3; padding-right: 10px">
                                                <img style="border-radius: 50%; height: 50px; width: 50px;" 
                                                    src="${pLocation.user.imageUrl || '/assets/images/no_image.jpg'}">
                                            </div>
                                            <div style="padding-left: 8px">
                                                <a target="_blank" href="/location/monitoring-user-timeline?userCode=${pLocation.user.code}&userId=${pLocation.user.id}" style="font-size: 12px; font-family: Muli; margin-left: 4px">
                                                    ${pLocation.user.name} (${pLocation.user.code})
                                                </a>
                                                <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center;">
                                                    <img style="height: 20px; width: 20px;" src="/assets/icons/markers/battery.svg">
                                                    ${pLocation.batteryStatus ? (pLocation.batteryStatus * 100) + '%' : 'N/A'}
                                                </div>
                                                ${pLocation.durationInSeconds > 0 ? `
                                                <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center;">
                                                    <img style="height: 20px; width: 20px;" src="/assets/icons/markers/clock.svg">
                                                    ${pLocation.durationInWord}
                                                </div>
            
                                                ` : ''}
                                                         <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center;">
                                                    Address: ${pLocation.address}
                                                </div>
                                                 <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center;">
                                                      Updated on: ${lastUpdated}
                                                 </div>  
                                            </div>
                                        </div>
                                        `, {minWidth: 200});
                                            this.markerClusterGroup.addLayer(marker);
                                        }
                            });
                this.map.addLayer(this.markerClusterGroup);
            }
        }, error => {
            this.loadingData = false;
        });
    }


}
